import {
  doublePrecision,
  foreignKey,
  integer,
  pgTable,
  primaryKey,
  uuid,
} from "drizzle-orm/pg-core";
import { food, foodMeta } from "../food/food.sql";
import { nutrient } from "../nutrient/nutrient.sql";
import { relations } from "drizzle-orm";

export const genericFood = pgTable(
  "generic_food",
  {
    id: uuid("id").notNull(),
    version: integer("version").notNull(),
  },
  (t) => [
    primaryKey({ name: "generic_food_pk", columns: [t.id, t.version] }),
    foreignKey({
      name: "generic_food_food_fk",
      columns: [t.id, t.version],
      foreignColumns: [food.id, food.version],
    }),
  ],
);

export const genericFoodRelations = relations(genericFood, ({ one }) => ({
  base: one(food, {
    fields: [genericFood.id, genericFood.version],
    references: [food.id, food.version],
  }),
  meta: one(foodMeta, {
    fields: [genericFood.id],
    references: [foodMeta.id],
  }),
  metaIfCurrent: one(foodMeta, {
    fields: [genericFood.id, genericFood.version],
    references: [foodMeta.id, foodMeta.currentVersion],
  }),
}));

export const genericFoodNutrient = pgTable(
  "generic_food_nutrient",
  {
    foodId: uuid("food_id").notNull(),
    foodVersion: integer("food_version").notNull(),
    nutrientId: uuid("nutrient_id")
      .references(() => nutrient.id)
      .notNull(),
    amountPer100g: doublePrecision("amount_per_100g").notNull(),
  },
  (t) => [
    primaryKey({
      name: "generic_food_nutrient_pk",
      columns: [t.foodId, t.foodVersion, t.nutrientId],
    }),
    foreignKey({
      name: "generic_food_nutrient_food_fk",
      columns: [t.foodId, t.foodVersion],
      foreignColumns: [genericFood.id, genericFood.version],
    }),
  ],
);
